export class requestGetStats {
    dealerGroupId: string;
    dealerShipId: number;
    year: number;
    month: number;
    quarter: number;
    constructor (data) {
        this.dealerGroupId = data.dealerGroupId;
        this.dealerShipId = data.dealerShipId;
        this.year = data.year;
        this.month =  data.month;
        this.quarter = data.quarter;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/req/request-get-stats.ts